'use strict'

exports.__esModule = true
exports.ReactNativeFile = void 0

var ReactNativeFile = function ReactNativeFile(_ref) {
  var uri = _ref.uri,
    name = _ref.name,
    type = _ref.type
  this.uri = uri
  this.name = name
  this.type = type
}

exports.ReactNativeFile = ReactNativeFile



//////////////////
// WEBPACK FOOTER
// ./~/extract-files/lib/ReactNativeFile.js
// module id = 326
// module chunks = 0